module.exports = __webpack_public_path__ + "media/img/illustrations/icons/applications-gender-male-2c4ab09f63883968d1a85837ee97208b.svg";